import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import Routes from './routes';
import { ConfigProvider } from './context/configContext';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <GoogleReCaptchaProvider
    reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
    language={process.env.REACT_APP_RECAPTCHA_LANGUAGE}
  >
    <ConfigProvider>
      <Router basename="/">
        <Routes />
      </Router>
    </ConfigProvider>
  </GoogleReCaptchaProvider>,
);
reportWebVitals();
